import React from "react";
import moment from "moment";
import { useCommonReducer } from "../../redux/slice/commonSlice";

const Footer: React.FC = () => {
  const commonReducer = useCommonReducer();
  const thisYear = moment().format("YYYY");

  return (
    <div className="text-center mt-5">
      <div className="footer fixed-bottom pt-2 pb-2">
        <div className="text-light footer-text ms-5">
          {`Copyright © ${thisYear} Conscisys Corporation - Ver. ${commonReducer.applicationData?.applicationVersion}`}
        </div>
      </div>
    </div>
  );
};

export default Footer;
